import {
  ColumnApiModule,
  EventApiModule,
  ModuleRegistry,
  NumberEditorModule,
  PaginationModule,
  RenderApiModule,
  RowApiModule,
  RowDragModule,
  RowSelectionModule,
  ValidationModule,
} from "ag-grid-community";
import {
  CellSelectionModule,
  CellStyleModule,
  ClientSideRowModelApiModule,
  ClientSideRowModelModule,
  ClipboardModule,
  ColumnAutoSizeModule,
  ColumnMenuModule,
  ContextMenuModule,
  CsvExportModule,
  CustomEditorModule,
  ExcelExportModule,
  ExternalFilterModule,
  GroupFilterModule,
  HighlightChangesModule,
  LicenseManager,
  MasterDetailModule,
  QuickFilterModule,
  RichSelectModule,
  RowAutoHeightModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  RowStyleModule,
  ServerSideRowModelApiModule,
  ServerSideRowModelModule,
  TextEditorModule,
  TextFilterModule,
  TooltipModule,
  UndoRedoEditModule,
} from "ag-grid-enterprise";

interface SetupAgGridOptions {
  licenseKey: string;
  includeValidation?: boolean;
}

export const setupAgGrid = (options: SetupAgGridOptions) => {
  // Set license key
  LicenseManager.setLicenseKey(options.licenseKey);

  // Register all modules
  const modules = [
    ClientSideRowModelModule,
    RowGroupingModule,
    CellSelectionModule,
    ContextMenuModule,
    ColumnMenuModule,
    GroupFilterModule,
    RowGroupingPanelModule,
    RowSelectionModule,
    RowApiModule,
    RowDragModule,
    CellStyleModule,
    RowStyleModule,
    TooltipModule,
    ClientSideRowModelApiModule,
    UndoRedoEditModule,
    HighlightChangesModule,
    CustomEditorModule,
    ColumnAutoSizeModule,
    NumberEditorModule,
    TextEditorModule,
    RichSelectModule,
    QuickFilterModule,
    MasterDetailModule,
    PaginationModule,
    RenderApiModule,
    ClipboardModule,
    ServerSideRowModelModule,
    ServerSideRowModelApiModule,
    EventApiModule,
    ColumnApiModule,
    ExternalFilterModule,
    RowAutoHeightModule,
    CsvExportModule,
    ExcelExportModule,
    TextFilterModule,
    ...(options.includeValidation ? [ValidationModule] : []),
  ];

  ModuleRegistry.registerModules(modules);
};
